module.exports = __webpack_public_path__ + "static/media/home-decor-3.2d98a7aa.jpeg";